// import { REPORT_CHANNEL, ZT_ROOT_ADDRESS } from '@src/constants';
// import queryParams from '@src/utils/getAppId';
import { LANGUAGE_NAME } from '@src/utils/locale';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';

const lang = getLanguageByPath();

export const config = {
  appId: '111111681',
  appVersion: '1.0',
  channel: 'mobile',
  createCommonAttributes: () => {
    return {
      //
      language: LANGUAGE_NAME[getLanguageByPath()]
      //post_url: ZT_ROOT_ADDRESS
    };
  }
};

const gaTrackerBaseEvent = {
  // 发送埋点
  send: (event_name, event_options = {}) => {
    // eslint-disable-next-line no-undef
    if (window.dataLayer) {
      // eslint-disable-next-line no-undef
      function gtag() {
        window.dataLayer.push(arguments);
      }
      gtag('event', event_name, {
        langCode: lang,
        ...event_options,
        transport_type: 'beacon'
      });
    }
  }
};

let startTimeTpl = 0;

export default function createTracker(report, getDiffRouteTime) {
  return {
    // 顶部导航栏-首页
    clickMainNaviBarHome: function () {
      gaTrackerBaseEvent.send('click_MainNaviBar_home');
    },
    // 顶部导航栏-新闻资讯
    clickMainNaviBarNews: function () {
      gaTrackerBaseEvent.send('click_MainNaviBar_news');
    },
    // 顶部导航栏-游戏介绍-游戏玩法
    clickMainNaviBarCombat: function () {
      gaTrackerBaseEvent.send('click_MainNaviBar_combat');
    },
    // 顶部导航栏-游戏介绍-机兵介绍
    clickMainNaviBarStrikers: function () {
      gaTrackerBaseEvent.send('click_MainNaviBar_strikers');
    },
    // 顶部导航栏-游戏介绍-王牌档案
    clickMainNaviBarCustom: function () {
      gaTrackerBaseEvent.send('click_MainNaviBar_custom');
    },
    // 顶部导航栏-游戏介绍-边缘战场
    clickMainNaviBar6v6maps: function () {
      gaTrackerBaseEvent.send('click_MainNaviBar_6v6maps');
    },
    // 顶部导航栏-游戏介绍-王牌序列
    clickMainNaviBar3v3maps: function () {
      gaTrackerBaseEvent.send('click_MainNaviBar_3v3maps');
    },
    // 顶部导航栏-游戏介绍-世界观
    clickMainNaviBarWorld: function () {
      gaTrackerBaseEvent.send('click_MainNaviBar_world');
    },
    // 顶部导航栏-游戏介绍-壁纸
    clickMainNaviBarWallpaper: function () {
      gaTrackerBaseEvent.send('click_MainNaviBar_wallpaper');
    },
    // 顶部导航栏-游戏介绍-风暴行动
    clickMainNaviBarstorm: function () {
      gaTrackerBaseEvent.send('click_MainNaviBar_storm');
    },
    // 顶部导航栏-游戏介绍-风暴行动-玛什玛克
    clickMainNaviBarStormSashmak: function () {
      gaTrackerBaseEvent.send('click_MainNaviBar_storm_mashmak');
    },
    // 顶部导航栏-活动专区-创作者活动
    clickMainNaviBarCR: function () {
      gaTrackerBaseEvent.send('click_MainNaviBar_CR');
    },
    // 顶部导航栏-活动专区-客服中心
    clickMainNaviBarSC: function () {
      gaTrackerBaseEvent.send('click_MainNaviBar_SC');
    },
    // 顶部导航栏-活动专区-造型排行
    clickMainNaviBarSR: function () {
      gaTrackerBaseEvent.send('click_MainNaviBar_SR');
    },
    // 顶部导航栏-活动专区-先驱小队活动
    clickMainNaviBarPT: function () {
      gaTrackerBaseEvent.send('click_MainNaviBar_PT');
    },
    // 顶部导航栏-活动专区-Twitch Drops
    clickMainNaviBarTD: function () {
      gaTrackerBaseEvent.send('click_MainNaviBar_TD');
    },
    // 顶部导航栏-礼包中心-特装机典藏版
    clickMainNaviBarCB: function () {
      gaTrackerBaseEvent.send('click_MainNaviBar_CB');
    },
    // 顶部导航栏-登录
    clickMainNaviBarLogin: function () {
      gaTrackerBaseEvent.send('click_MainNaviBar_login');
    },
    // 顶部导航栏-音乐
    clickMainNaviBarMusic: function () {
      gaTrackerBaseEvent.send('click_MainNaviBar_music');
    },
    // 顶部导航栏-语言-英文
    clickMainNaviBarEnglish: function () {
      gaTrackerBaseEvent.send('click_MainNaviBar_English');
    },
    // 顶部导航栏-语言-繁中
    clickMainNaviBarTC: function () {
      gaTrackerBaseEvent.send('click_MainNaviBar_TC');
    },
    // 顶部导航栏-语言-日文
    clickMainNaviBarJapanese: function () {
      gaTrackerBaseEvent.send('click_MainNaviBar_Japanese');
    },
    // 顶部导航栏-语言-韩文
    clickMainNaviBarKorean: function () {
      gaTrackerBaseEvent.send('click_MainNaviBar_Korean');
    },
    // 顶部导航栏-语言-泰文
    clickMainNaviBarThai: function () {
      gaTrackerBaseEvent.send('click_MainNaviBar_Thai');
    },
    // 顶部导航栏-语言-西班牙文
    clickMainNaviBarSpanish: function () {
      gaTrackerBaseEvent.send('click_MainNaviBar_Spanish');
    },
    // 顶部导航栏-语言-俄文
    clickMainNaviBarRussian: function () {
      gaTrackerBaseEvent.send('click_MainNaviBar_Russian');
    },
    // 顶部导航栏-语言-德文
    clickMainNaviBarGerman: function () {
      gaTrackerBaseEvent.send('click_MainNaviBar_German');
    },
    // 顶部导航栏-语言-法文
    clickMainNaviBarFrench: function () {
      gaTrackerBaseEvent.send('click_MainNaviBar_French');
    },
    // 顶部导航栏-语言-葡文
    clickMainNaviBarPortuguese: function () {
      gaTrackerBaseEvent.send('click_MainNaviBar_Portuguese');
    },
    // 顶部导航栏-分享-Discord
    clickMainNaviBarDiscord: function () {
      gaTrackerBaseEvent.send('click_MainNaviBar_discord');
    },
    // 顶部导航栏-分享-YouTube
    clickMainNaviBarYoutube: function () {
      gaTrackerBaseEvent.send('click_MainNaviBar_Youtube');
    },
    // 顶部导航栏-分享-X(Twitter)
    clickMainNaviBarTwitter: function () {
      gaTrackerBaseEvent.send('click_MainNaviBar_Twitter');
    },
    // 顶部导航栏-分享-Facebook
    clickMainNaviBarFacebook: function () {
      gaTrackerBaseEvent.send('click_MainNaviBar_Facebook');
    },
    // 顶部导航栏-分享-Instagram
    clickMainNaviBarInstagram: function () {
      gaTrackerBaseEvent.send('click_MainNaviBar_Instagram');
    },
    // 顶部导航栏-分享-TikTok
    clickMainNaviBarTikTok: function () {
      gaTrackerBaseEvent.send('click_MainNaviBar_TikTok');
    },
    // 顶部导航栏-分享-Twitch
    clickMainNaviBarTwitch: function () {
      gaTrackerBaseEvent.send('click_MainNaviBar_Twitch');
    },
    // 顶部导航栏-分享-Naver
    clickMainNaviBarNaver: function () {
      gaTrackerBaseEvent.send('click_MainNaviBar_Naver');
    },
    // 顶部导航栏-分享-VK
    clickMainNaviBarVK: function () {
      gaTrackerBaseEvent.send('click_MainNaviBar_VK');
    },
    // 首页-立即预约
    clickHomeReserve: function () {
      gaTrackerBaseEvent.send('click_Home_reserve');
    },
    // 首页-立即下载
    clickHomeDownload: function () {
      gaTrackerBaseEvent.send('click_Home_download');
    },
    // 首页-Steam
    clickHomeSteam: function () {
      gaTrackerBaseEvent.send('click_Home_steam');
    },
    // 首页-Xbox
    clickHomeXbox: function () {
      gaTrackerBaseEvent.send('click_Home_xbox');
    },
    // 首页-Google Play Games
    clickHomeGPG: function () {
      gaTrackerBaseEvent.send('click_Home_gpg');
    },
    // 首页-侧边浮窗
    clickHomeSidebar: function (Entrance) {
      gaTrackerBaseEvent.send('click_Home_sidebar', {
        Entrance
      });
    },
    // 首页-侧边浮窗-公测礼包-领取奖励
    clickHomeBGRewards: function () {
      gaTrackerBaseEvent.send('click_Home_BG_rewards');
    },
    // 特装机典藏版-立即预约
    clickCBReserve: function () {
      gaTrackerBaseEvent.send('click_CB_reserve');
    },
    // 特装机典藏版-查看详情（美亚）
    clickCBAMZNUS: function () {
      gaTrackerBaseEvent.send('click_CB_AMZNUS');
    },
    // 特装机典藏版-查看详情（日亚）
    clickCBAMZNJP: function () {
      gaTrackerBaseEvent.send('click_CB_AMZNJP');
    },
    // 登录成功
    formSubmitLogin: function () {
      gaTrackerBaseEvent.send('form_submit_login');
    },
    pageLoadDuration: function (region) {
      const endTimeTpl = new Date().getTime();
      startTimeTpl = new Date().getTime();
      const tpl = endTimeTpl - startTimeTpl;
      const customEventInfo = {
        eventId: 'page_load_duration', //事件ID
        eventDesc: '用户点进来页面loading加载时长', //事件描述
        eventBody: {
          td_pl: getDiffRouteTime(),
          region: region
        }
      };
      report(customEventInfo);
      // gaTrackerBaseEvent.send('click_start_code');
    },
    clickMESSAGE: function () {
      // const customEventInfo = {
      //   eventId: 'click_dlcmsmk_register', //事件ID
      //   eventDesc: '首页-测试报名，需要可区分五语言（繁中、英语、日语、韩语葡萄牙语）查看数据', //事件描述
      //   eventBody: {}
      // };
      // report(customEventInfo);
      gaTrackerBaseEvent.send('click_MESSAGE');
    }
  };
}

Number.isInteger =
  Number.isInteger ||
  function (value) {
    return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
  };

function checkTypeHOF(type) {
  switch (type) {
    case 'int':
      return Number.isInteger;
    case 'float':
      return value => typeof value === 'number' && !Number.isInteger(value);
    case 'boolean':
      return value => typeof value === 'boolean';
    case 'string':
      return value => typeof value === 'string';
    default:
      setTimeout(() => {
        throw new Error('st-report: invalid value type = ' + type);
      }, 0);
      return null;
  }
}
